var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9743 1.29616C19.9273 1.61217 17.4586 4.46948 16.0129 7.002C15.8439 6.73426 14.8475 5.13224 14.6785 4.88206C12.6457 2.0862 9.54975 0.422723 6.15134 1.91063C4.64763 2.59898 3.37237 3.69366 2.47332 5.06783C1.57427 6.442 1.08823 8.03941 1.07153 9.67497C1.07153 20.6126 16.0263 28.2453 16.0263 28.2453C16.0263 28.2453 30.9766 20.6126 30.9766 9.67497C30.9766 6.32169 28.6102 2.65239 25.2963 1.54633C24.5502 1.29638 23.7576 1.21098 22.9743 1.29616Z",
    fill: "#EB5757",
    stroke: "#434341",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCor);
export default __webpack_public_path__ + "static/media/cor.ab8579d202bc9eacaa7d0f200d78c7b1.svg";
export { ForwardRef as ReactComponent };